import { Analytics } from "@/shared/utils/analytics/analytics";
import { debounce } from "@sazka/utils/debounce";

export const useFooter = () => {
    let isDesktop = getIsDesktop();
    removeAccordions(isDesktop);
    addAccordions(isDesktop);

    window.addEventListener(
        "resize",
        debounce(() => {
            const newIsDesktop = getIsDesktop();
            if (isDesktop == newIsDesktop) return;

            isDesktop = newIsDesktop;
            removeAccordions(isDesktop);
            addAccordions(isDesktop);
        }, 200)
    );

    const footerItemsForAnalytics = document.querySelectorAll<HTMLElement>(
        ".footer__link[data-a-codename]:not([data-a-codename=''])"
    );
    footerItemsForAnalytics.forEach((item) =>
        item.addEventListener("click", () => Analytics.pushMenuClick(item.dataset.aCodename, "footer"))
    );
};

function getIsDesktop() {
    return window.matchMedia("(min-width: 48em)").matches;
}

function removeAccordions(isDesktop: boolean) {
    const accordionControls = $(".footer__title"),
        accordionContents = $(".footer__nav");

    if (isDesktop) {
        accordionControls.removeAttr("data-target").removeAttr("data-toggle").removeClass("collapsed");
        accordionContents.removeClass("collapse");
    }
}

function addAccordions(isDesktop: boolean) {
    if (!isDesktop) {
        const accordionControls = $(".footer__title"),
            accordionContents = $(".footer__nav");

        accordionControls.attr("data-toggle", "collapse").addClass("collapsed");

        $(accordionControls).each(function (index) {
            $(this).attr("data-target", "#footerAcc" + (index + 1));
        });

        accordionContents.addClass("collapse");

        $(accordionContents).each(function (index) {
            $(this).attr("id", "footerAcc" + (index + 1));
        });
    }
}
